import styled from "@emotion/styled";
import React from "react";
import { STRINGS } from "../../../../strings";
import { translate } from "../../../../translate";
import AnimatedModal from "../../../AnimatedModal";
import { AppButton } from "../../AppButton";
import { AppOverlay } from "../../AppOverlay";

type Props = {
  isOpen: boolean;
  onRequestClose: () => void;
};

export default function CareMomentStreakBreakModal(props: Props) {
  return (
    <AppOverlay>
      <AnimatedModal.Styled isOpen={props.isOpen} onRequestClose={props.onRequestClose}>
        <AnimatedModal.AnimationWrapper offset={0}>
          <Image src="/assets/wooden-blocks-arrow-table.jpg" alt="demotion" />
        </AnimatedModal.AnimationWrapper>
        <AnimatedModal.Headline>{translate(STRINGS.STREAK_BREAK)}</AnimatedModal.Headline>

        <FirstParagraph>{translate(STRINGS.STREAK_BREAK_MESSAGE)}</FirstParagraph>

        <AnimatedModal.Message>{translate(STRINGS.STREAK_BREAK_MESSAGE_2)}</AnimatedModal.Message>

        <AnimatedModal.Actions>
          <AppButton size="large" onClick={props.onRequestClose}>
            {translate(STRINGS.GOT_IT)}
          </AppButton>
        </AnimatedModal.Actions>
      </AnimatedModal.Styled>
    </AppOverlay>
  );
}

const Image = styled.img`
  max-height: 128px;
  max-width: 100%;
`;

const FirstParagraph = styled(AnimatedModal.Message)`
  margin-bottom: 12px;
`;
